module.exports = __webpack_public_path__ + "static/media/close-icon-pa.62ee2eec.svg";